import { CompanyType, CreateAccount, CreateAddress, MembershipType } from "@/types";
import { eoriNumberValidation, leiNumberValidation } from "@/utils/ValidationHelper";
import { z } from "zod";

const address: z.ZodType<CreateAddress> = z.any();
const bankAccount: z.ZodType<CreateAccount> = z.any();
const companyType: z.ZodType<CompanyType> = z.any();
const membershipType: z.ZodType<MembershipType> = z.any();

const validationSchema = z.object({
  name: z.string({ message: "validation:companyNameRequired" }).min(1, "validation:companyNameRequired"),
  email: z
    .string({ message: "validation:emailRequired" })
    .min(1, "validation:emailRequired")
    .email("validation:emailFormatError"),
  invoiceEmail: z
    .string({ message: "validation:invoiceEmailRequired" })
    .min(1, "validation:invoiceEmailRequired")
    .email("validation:invoiceEmailFormatError"),
  notificationEmail: z
    .string({ message: "validation:notificationEmailRequired" })
    .min(1, "validation:notificationEmailRequired")
    .email("validation:notificationEmailFormatError"),
  vatNumber: z.string({ message: "validation:vatNumberRequired" }).min(1, "validation:vatNumberRequired"),
  leiNumber: leiNumberValidation.optional(),
  eoriNumber: eoriNumberValidation.optional(),
  phone: z.string({ message: "validation:phoneNumberRequired" }).min(1, "validation:phoneNumberRequired"),
  address: z.array(address).min(1, "validation:missingAddress"),
  countryCodeIso3: z.string({ message: "validation:countryRequired" }).min(1, "validation:countryRequired"),
  languageId: z.number({ message: "validation:languageRequired" }).min(1, "validation:languageRequired"),
  bankAccount: z.array(bankAccount).min(1, "validation:missingBankAccount"),
  defaultCurrency: z.string({ message: "validation:currencyRequired" }).min(1, "validation:currencyRequired"),
  transport: z.boolean(),
  companyType: companyType,
  timeZone: z.string({ message: "validation:timeZoneRequired" }),
  membership: membershipType,
  exportLicense: z.string().optional(),
  allowCollectiveInvoice: z.boolean(),
});

export const CreateCompanyValidationSchema = validationSchema;
export type CreateCompanyFormInput = z.infer<typeof CreateCompanyValidationSchema>;
